import React from "react";
import { connect } from "react-redux";
import { Segment, Form, Dropdown, Message, Button } from "semantic-ui-react";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";

import * as SECTION_ACTIONS from "../../../../actions/sectionActions";
import QuestionSelectComponent from "./QuestionSelectComponent";

export function ConditionComponent(props) {
  const state = { condition: props.condition || {} };
  const setState = update => {
    const next = typeof update === "function" ? update(state) : update;
    props.onConditionEdit(next.condition);
  };
  const {
    register,
    formState: { errors },
    setValue,
    control,
  } = useForm({
    mode: "all",
    reValidateMode: "onBlur",
  });

  const operatorTypes = [
    { key: 1, text: "equals", value: "is_equal" },
    { key: 2, text: "does not equal", value: "is_not_equal" },
    { key: 3, text: "contains", value: "contains" },
    // { key: 4, text: 'less than', value: 'less_than' },
    // { key: 5, text: 'greater than', value: 'greater_than' },
    // { key: 6, text: 'less than or equal to', value: 'less_than_equal_to' },
    // { key: 7, text: 'greater than or equal to', value: 'greater_than_equal_to' },
  ];

  const changeSection = (value) => {
    setState((prevState) => ({
      ...prevState,
      condition: {
        ...prevState.condition,
        targetSectionId: value,
        targetQuestionId: null,
      },
    }));
  };

  const changeQuestion = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        condition: { ...prevState.condition, targetQuestionId: value },
      };
    });
  };

  const sectionDropdown = () => {
    let sectionItems = props.sectionLookups.map((section) => {
      return {
        key: section.id,
        text:
          section.parentSectionId === null ||
            section.parentSectionId === undefined
            ? `${section.displayName} (Main Section)`
            : `${section.displayName} (Subsection)`,
        value: section.id,
      };
    });



    return (
      <Controller
        name="section"
        control={control}
        rules={{ required: "Select a section" }}
        setValue={setValue}
        render={({ field, fieldState, formState }) => {
          return (
            <div>
              <Dropdown
                className={fieldState.error ? "invalid-input-field" : ""}
                {...field}
                placeholder="Select a section"
                fluid
                selection
                search
                options={sectionItems}
                value={state.condition.targetSectionId || ""}
                onChange={(e, { value }) => {
                  field.onChange(value);
                  changeSection(value);
                }}
              />
              {fieldState.invalid && (
                <p className="validation-error">* Select a section</p>
              )}
            </div>
          );
        }}
      />
    );
  };

  const questionDropdown = () => {
    return (
      <Controller
        name="Question"
        control={control}
        rules={{ required: "Select a question" }}
        setValue={setValue}
        render={({ field, fieldState, formState }) => {
          return (
            <div>
              <QuestionSelectComponent
                field={{ ...field }}
                sectionId={state.condition.targetSectionId}
                excludeId={props.questionId}
                questionaire={props.questionaire}
                onQuestionSelectedChanged={changeQuestion}
                selectedQuestionId={state.condition.targetQuestionId}
              />
              {fieldState.invalid && (
                <p className="validation-error">* Select a question</p>
              )}
            </div>
          );
        }}
      />
    );
  };

  const operatorDropdown = () => {
    return (
      <Controller
        name="operator"
        control={control}
        rules={{ required: "Select a operator" }}
        setValue={setValue}
        render={({ field, fieldState, formState }) => {
          return (
            <div>
              <Dropdown
                className={fieldState.error ? "invalid-input-field" : ""}
                {...field}
                placeholder="Operator"
                fluid
                selection
                search
                options={operatorTypes}
                value={state.condition.conditionOperator || ""}
                onChange={(e, { value }) => {
                  setState((prevState) => ({
                    condition: {
                      ...prevState.condition,
                      conditionOperator: value,
                    },
                  }));
                  field.onChange(value);
                }}
              />
              {fieldState.invalid && (
                <p className="validation-error">* Select an operator</p>
              )}
            </div>
          );
        }}
      />
    );
  };

  if (props.loadStatus === 'loading') return <Message info content="Loading the saved condition…" />;
  if (props.loadStatus === 'error') return <Message negative>
    <p>The saved condition could not be loaded. Retry before editing or saving it.</p>
    <Button type="button" size="small" onClick={props.onRetry}>Retry loading condition</Button>
  </Message>;
  return (
    <Segment secondary>
      {props.selectionWarning && <Message warning content="Several saved conditions have the same or missing dates. The first saved condition is shown, matching questionnaire delivery. Review it and save any changes you need." />}
      <Form.Field>
        <label>Question depends on section:</label>
        {sectionDropdown()}
      </Form.Field>
      {!_.isEmpty(state.condition) && questionDropdown()}
      <Form.Field>
        <label>Question dependent when:</label>
        {operatorDropdown()}
      </Form.Field>
      <Form.Field>
        <label>And value is: </label>
        <input
          name="condition_value"
          className={errors.condition_value ? "invalid-input-field" : ""}
          {...register("condition_value", { required: true, maxLength: 255 })}
          placeholder="Value"
          value={state.condition.value || ""}
          onChange={(e) => {
            setState((prevState) => ({
              condition: { ...prevState.condition, value: e.target.value },
            }));
          }}
        />
        {errors.condition_value &&
          errors.condition_value.type === "required" && (
            <p className="validation-error">* Please enter a value</p>
          )}
        {errors.condition_value &&
          errors.condition_value.type === "pattern" && (
            <p className="validation-error">
              * May only contain alphanumerical characters
            </p>
          )}
        {errors.condition_value &&
          errors.condition_value.type === "maxLength" && (
            <p className="validation-error">
              * Description may not be more than 255 characters long
            </p>
          )}
      </Form.Field>
    </Segment>
  );
}

ConditionComponent.defaultProps = {
  targetSectionId: 0,
  targetQuestionId: 0,
  sectionId: 0,
  questionId: 0,
  questionaireId: null,
  isSectionCondition: false,
  onConditionEdit: () => { },
};

const mapStateToProps = (state, ownProps) => {
  return {
    condition: ownProps.condition || {},
    sectionLookups: _.isEmpty(state.sections) ? [] : Object.values(state.sections).filter((section) => section.questionaireId === ownProps.questionaire.id && section.status !== "isDeleted"),
    questionLookups: _.isEmpty(state.questions) ? [] : Object.values(state.questions).filter((question) => question.questionaireId === ownProps.questionaire.id && question.status !== "isDeleted"),
    tenantId: state.tenantManagement.activeTenant.tenantId
  };
};

export default connect(
  // map state to props
  mapStateToProps,
  // map dispatch to props
  (dispatch, ownProps) => ({
    fetchAllSectionsAction: (questionaireId, sectionId) => dispatch(SECTION_ACTIONS.fetchSectionListWsAction(questionaireId, sectionId)),
  })
)(ConditionComponent);
